import { render, staticRenderFns } from "./BottomBarCarrinho.vue?vue&type=template&id=2e00a194&scoped=true&"
import script from "./BottomBarCarrinho.vue?vue&type=script&lang=js&"
export * from "./BottomBarCarrinho.vue?vue&type=script&lang=js&"
import style0 from "./BottomBarCarrinho.vue?vue&type=style&index=0&id=2e00a194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00a194",
  null
  
)

export default component.exports